import { FloorplanResult, UnitResult } from "./types";

export const getVisibleFloorplans = (
  floorplans: FloorplanResult[],
  unitsByFloorplan: Map<string, UnitResult[]>,
  selectedFloorplans: string[]
): FloorplanResult[] =>
  floorplans.filter(
    (fp) =>
      (unitsByFloorplan.get(fp.unitType) ?? []).length > 0 &&
      (selectedFloorplans.length === 0 ||
        selectedFloorplans.includes(fp.unitType))
  );
